import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { EmailProvidersUrlService } from '@core/email-providers-data';
import { EmailProviders } from '@core/email-providers-types';
import type { EmailProvider } from '@core/email-templates-types';
import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import { IntegrationLegalDialogService } from '@core/integrations-legacy';
import type { DialogComponentI } from '@core/user-interface-legacy';
import {
  ButtonComponent,
  DialogBodyComponent,
  DialogHeaderComponent,
  DialogRef,
  DividerComponent,
  GroupComponent,
  HeadingComponent,
  IconComponent,
  MessageComponent,
} from '@core/user-interface-legacy';

interface EmailProviderGoogleDialogData {
  emailProvider: EmailProvider;
  errorMessage: string;
  returnTo?: 'academy';
  errorProvider: string;
}

@Component({
  selector: 'rt-email-provider-google',
  templateUrl: './email-provider-google-dialog.component.html',
  styleUrls: ['./email-provider-google-dialog.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DialogHeaderComponent,
    DialogBodyComponent,
    MessageComponent,
    ButtonComponent,
    DividerComponent,
    GroupComponent,
    IconComponent,
    HeadingComponent,
    TranslatePipe,
  ],
})
export class EmailProviderGoogleDialogComponent
  implements DialogComponentI<EmailProviderGoogleDialogData, void>
{
  private readonly emailProvidersUrlService = inject(EmailProvidersUrlService);
  private readonly dialog = inject(DialogRef);
  private readonly integrationLegalDialogService = inject(IntegrationLegalDialogService);
  private readonly i18n = inject(I18nService);

  public connectUrl: string;
  public errorMessage: string | null;
  public emailProvider: EmailProvider;
  public EmailProviders = EmailProviders;
  public errorProvider: string;

  private returnTo: EmailProviderGoogleDialogData['returnTo'];

  public setDialogData(data: EmailProviderGoogleDialogData): void {
    if (data) {
      if (data.emailProvider) {
        this.emailProvider = data.emailProvider;
      }
      if (data.errorMessage) {
        this.errorMessage = data.errorMessage;
      }
      if (data.returnTo) {
        this.returnTo = data.returnTo;
      }
      if (data.errorProvider) {
        this.errorProvider = data.errorProvider;
      }
    }
  }

  public ngOnInit(): void {
    this.connectUrl = this.emailProvidersUrlService.googleConnectUrl(this.returnTo);
  }

  public connectClick(): void {
    this.integrationLegalDialogService
      .openLegalDialog(null, this.i18n.translate('app.email_provider_google.name'), undefined, {
        helpArticleUrl: this.i18n.translate('app.email_provider_google.help_article_link'),
      })
      .subscribe(result => {
        if (result && result.accepted) {
          window.location.href = this.connectUrl;
        }
      });
  }

  public cancelClick(): void {
    this.dialog.close();
  }

  public get googleConnected(): boolean {
    return this.emailProvider.connected && this.emailProvider.provider === EmailProviders.Google;
  }
}
